// theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    fontFamily: `'Montserrat', 'sans-serif'`, // ตั้งค่าฟอนต์หลัก
    palette: {
        primary: {
            main: '#3dbb89',
            dark: '#1b787a',
            light: '#F3FAF8',
        },
        info: {
            main: '#049dd0'
        },
        grey: {
            main: '#e5e5e5',
            dark: '#939298',
        },
    },
    typography: {
        h3: {
            fontSize: '25px',
            fontWeight: 600, // น้ำหนักตัวอักษร
            // textShadow: "1px 2px 4px rgba(0, 0, 0, 0.4)", // เพิ่มเงาตัวอักษร
        },
        h4: {
            fontSize: '20px',
            fontWeight: 600, // น้ำหนักตัวอักษร
            // textShadow: "1px 2px 4px rgba(0, 0, 0, 0.4)", // เพิ่มเงาตัวอักษร
        },
        h5: {
            fontSize: '15px',
            fontWeight: 600, // น้ำหนักตัวอักษร
            // textShadow: "1px 2px 4px rgba(0, 0, 0, 0.4)", // เพิ่มเงาตัวอักษร
        },
        h6: {
            fontSize: '12px',
            fontWeight: 600, // น้ำหนักตัวอักษร
            // textShadow: "1px 2px 3px rgba(0, 0, 0, 0.2)", // เพิ่มเงาตัวอักษร
        },
        h7: {
            fontSize: '14px',
            fontWeight: 500, // น้ำหนักตัวอักษร
        },
        button: {
            textTransform: "none"
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: '#ffffff',
                    borderRadius: '12px',
                    '&:hover': {
                        boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.2)',
                    },
                    '&.Mui-disabled': {
                        background: 'linear-gradient(to right bottom, #e0e0e0, #f5f5f5)', // ใช้ background สำหรับ gradient
                        boxShadow: 'none', // ปิดเงา
                        cursor: 'not-allowed', // เปลี่ยน cursor เป็นแบบห้าม
                    },
                },
                contained: {
                    background: `linear-gradient(to right bottom, #3dbb89, #1b787a)`, // Gradient สำหรับ variant="contained"
                },
                outlined: {
                    background: 'white', // ไม่มีสีพื้นหลัง
                    border: '1px solid rgb(221, 221, 221)', // สีของขอบ
                    color: '#3dbb89', // สีตัวอักษร
                    '&:hover': {
                        background: 'white', // พื้นหลังเบาเมื่อ hover
                    },
                },
                containedSuccess: {
                    background: `linear-gradient(to right bottom, #F3FAF8, #1b787a)`, // Gradient สำหรับ variant="contained"
                },
                containedError: {
                    background: `linear-gradient(to right bottom, #ef5350, #d32f2f)`, // Gradient สำหรับ variant="contained"
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '12px',
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    position: 'fixed',
                    margin: 'auto',
                    borderRadius: '16px',
                    height: '100%',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '0px 20px',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '10px',
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backdropFilter: "blur(2px)", // เทียบเท่ากับ Tailwind's backdrop-blur-sm
                    backgroundColor: "rgba(0, 0, 0, 0.1)", // เพิ่มความโปร่งแสง
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                circle: {
                    strokeLinecap: "round", // ให้ปลายเส้นโค้งมน
                },
            },
        },
    },
});

export default theme;